import dynamic from "next/dynamic";

export const DynamicLayoutWidget082 = dynamic(
  () => import("./LayoutWidget082"),
  {
    suspense: true,
  }
);
